module.exports = __webpack_public_path__ + "static/line-2066b9954d8608f399c42c4906286ef5.png";